<template>
  <div class="authorizationSuccess">
  </div>
</template>
<script>

export default {

  data() {
    return {
      show: false
    };
  },
  mounted() {
    this.brWxLogin()
  },
  methods: {
    brWxLogin() {
      let query = this.$route.query
      let datas = {
        code: query.code,
        state: query.state,
      }
      location.href = 'https://api.rakumart.com.br/index.php?mod=admin&act=login&code=' + query.code
      // window.parent.postMessage(datas, '*');
      // console.log(window.parent.postMessage);
    },
  }
}
</script>
<style lang='scss' scoped>
.authorizationSuccess {
  width: 600px;

  .success {
    padding: 30px;
    margin: 100px 30px;
    text-align: center;

    .title {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 30px;

      i {
        font-size: 60px;
        vertical-align: middle;
        color: rgb(111, 216, 130);
      }
    }

    p {
      font-size: 25px;
      margin-bottom: 40px;
    }

    .go {
      display: flex;
      justify-content: center;

      a {
        font-size: 30px;
        padding: 0 30px;
      }
    }
  }
}
</style>